import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appFormControlTooltip]',
  standalone: true,
})
export class FormControlTooltipDirective {
  @Input('appFormControlTooltip') public tooltip: string | TemplateRef<any> = '';
}
